import { ApolloError } from '@apollo/client';
import { GraphQLError, GraphQLErrorExtensions } from 'graphql';
import { TFunction } from 'i18next';
import { bpErrorsCodes, ErrorCodeType } from 'activate-errors';

interface GraphQLErrorWithException extends GraphQLErrorExtensions {
  exception?: ErrorCodeType;
}

export const getDeleteChargeCodeErrorMessage = (error: ApolloError | Error | unknown, t: TFunction): string => {
  const defaultMessage = t('abp.productsServices.deleteChargeCode.error');

  if (error && typeof error === 'object' && 'graphQLErrors' in error) {
    const apolloError = error as ApolloError;
    const firstGraphQLError = apolloError.graphQLErrors?.[0] as GraphQLError | undefined;
    const errorCode = (firstGraphQLError?.extensions as GraphQLErrorWithException)?.exception?.code;

    if (errorCode === bpErrorsCodes.chargeCodeSourceRestrictionError.code) {
      return t('abp.productsServices.deleteChargeCode.integrationSourceErrorMessage');
    }

    return apolloError.graphQLErrors?.[0]?.message || defaultMessage;
  }

  return defaultMessage;
};
